import * as React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from "react-router-dom";
import './ProcesoBreef.css';
import Tooltip from '@mui/material/Tooltip';

function ProcesoBreef(props) {

    const id = props.caseDict.id_proceso;
    const ddts = props.caseDict.demandantes;
    const ddos = props.caseDict.demandados;
    const fecha = props.caseDict.fecha;
    const clase = props.caseDict.clase;
    const radicado = props.caseDict.radicado;
    const [importante, setImportante] = React.useState(props.caseDict.is_importante);
    const [archive, setArchive] = React.useState(props.caseDict.is_archivado);
    const hide = props.caseDict.hide;

    async function modifyCase(id, boolean) {
        
        await fetch(`${props.url}/procesos-api/modify-case`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token '+ localStorage.getItem('token'),
            },
            body: JSON.stringify({
                token: localStorage.getItem('token'),
                idProceso: id,
                importante: boolean ? true : false,
            })
        })
        if (boolean) setImportante(!importante);
        else setArchive(!archive);
    }

    return(
        <React.Fragment>
            <div id={id} style={hide ? {'display': 'none'} : {'display': 'block'}}>
                <div className="tableContainer proceso-info-t-l">
                    <Table hover bordered={false}>
                        <tbody>
                            <tr>
                                <td colSpan="2" className="highlight">
                                    <Tooltip title="Marcar como importante">
                                        <span className="material-icons-round favorite" 
                                                style={importante ? {'color': 'var(--orange)'} : {'color': 'var(--light-gray)'}}
                                                onClick={() => modifyCase(id, true)}>
                                                star
                                        </span>
                                    </Tooltip>
                                    Demandante
                                </td>
                                <td colSpan="2" className="highlight">Demandado</td>
                                <td colSpan="2" className="highlight">Fecha</td>
                                <td colSpan="2" className="highlight">
                                    <Tooltip title="Archivar">
                                        <span className="material-icons-round archive" 
                                                style={archive ? {'color': 'var(--orange)'} : {'color': 'var(--light-gray)'}}
                                                onClick={() => modifyCase(id, false)}>
                                                do_not_disturb_on
                                        </span>
                                    </Tooltip>
                                    Clase
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" >{ddts}</td>
                                <td colSpan="2" >{ddos}</td>
                                <td nowrap="nowrap" colSpan="2" >{fecha}</td>
                                <td colSpan="2" >{clase}</td>
                            </tr>
                            <tr >
                                <th colSpan="8">
                                    <Tooltip title="Ver más">
                                        <Link id='codeLink' onClick={() => props.setOpenCaseInfo(props.caseDict)} 
                                            to={`/proceso/${id}`}>
                                            
                                            {radicado}
                                            
                                        </Link>
                                    </Tooltip>
                                </th>
                            </tr> 
                        </tbody>
                    </Table>
                </div>
                <div className="tableContainer proceso-info-t-m">
                    <Table striped bordered hover >
                        <tbody>
                            <tr>
                                <td colSpan="2" className="highlight">
                                    <Tooltip title="Marcar como importante">
                                        <span 
                                            className="material-icons-round favorite" 
                                            style={importante ? {'color': 'var(--orange)'} : {'color': 'var(--light-gray)'}}
                                            onClick={() => modifyCase(id, true)}>
                                            star
                                        </span>
                                    </Tooltip>
                                    Demandante
                                </td>
                                <td>{ddts}</td>
                                <td className="highlight">Demandado</td>
                                <td>
                                    {ddos}
                                    <Tooltip title="Archivar">
                                        <span 
                                            className="material-icons-round archive" 
                                            style={archive ? {'color': 'var(--orange)'} : {'color': 'var(--light-gray)'}}
                                            onClick={() => modifyCase(id, false)}>
                                            do_not_disturb_on
                                        </span>
                                    </Tooltip>
                                </td>
                            </tr>
                        
                            <tr>
                                <td className="highlight">Fecha</td>
                                <td nowrap="nowrap" >{fecha}</td>
                                <td className="highlight">Clase</td>
                                <td>{clase}</td>
                            </tr>
                            <tr >
                                <th colSpan="4">
                                    <Tooltip title="Ver más">
                                        <Link id='codeLink' onClick={() => props.setOpenCaseInfo(props.caseDict)} 
                                            to={`/proceso/${props.caseDict.idProceso}`}>
                                            
                                            {radicado}
                                            
                                        </Link>
                                    </Tooltip>
                                </th>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <div id={props.caseDict.idProceso} className="tableContainer proceso-info-t-s">
                    <Table striped bordered hover >
                        <tbody >
                            <tr>
                                <td className="highlight">
                                    <Tooltip title="Marcar como importante">
                                        <span className="material-icons-round favorite" 
                                            style={importante ? {'color': 'var(--orange)'} : {'color': 'var(--light-gray)'}}
                                            onClick={() => modifyCase(id, true)}>
                                            star
                                        </span>
                                    </Tooltip>
                                    Demandante
                                </td>
                                <td>
                                    {ddts}
                                    <Tooltip title="Archivar">
                                        <span className="material-icons-round archive" 
                                            style={archive ? {'color': 'var(--orange)'} : {'color': 'var(--light-gray)'}}
                                            onClick={() => modifyCase(id, false)}>
                                            do_not_disturb_on
                                        </span>
                                    </Tooltip>
                                </td>
                            </tr>
                            <tr>
                                <td>Demandado</td>
                                <td>{ddos}</td>
                            </tr>
                        
                            <tr>
                                <td>Fecha</td>
                                <td nowrap="nowrap" >{fecha}</td>
                            </tr>
                            <tr>
                                <td>Clase</td>
                                <td>{props.caseDict.clase}</td>
                            </tr>
                            <tr >
                                <th colSpan="2">
                                    <Tooltip title="Ver más">
                                        <Link id='codeLink' onClick={() => props.setOpenCaseInfo(props.caseDict)} 
                                            to={`/proceso/${props.caseDict.idProceso}`}>
                                            
                                            {radicado}
                                            
                                        </Link>
                                    </Tooltip>
                                </th>
                            </tr>
                        </tbody> 
                    </Table>
                </div>
            </div>
        </React.Fragment>
    )
}

export { ProcesoBreef }